import { useTranslation } from 'react-i18next';

type TppModalGuideProps = {
  introKey: string;
  stepKeys: string[];
  noteKey?: string;
  className?: string;
  /** true のとき `<details>` で折りたたみ（既定: 閉） */
  collapsible?: boolean;
};

function GuideContent({
  introKey,
  stepKeys,
  noteKey,
}: Pick<TppModalGuideProps, 'introKey' | 'stepKeys' | 'noteKey'>) {
  const { t } = useTranslation();

  return (
    <>
      <p className="mb-2 mb-md-2 fw-medium text-body">{t(introKey)}</p>
      <ol className="mb-0 ps-3 text-muted">
        {stepKeys.map((key) => (
          <li key={key} className="mb-1">
            {t(key)}
          </li>
        ))}
      </ol>
      {noteKey ? <p className="mb-0 mt-2 text-muted">{t(noteKey)}</p> : null}
    </>
  );
}

/** 交通IC管理モーダル向けの短い手順説明（初見向け） */
export default function TppModalGuide({
  introKey,
  stepKeys,
  noteKey,
  className,
  collapsible = false,
}: TppModalGuideProps) {
  const { t } = useTranslation();

  if (collapsible) {
    return (
      <details className={['small mb-3 rounded border bg-light', className].filter(Boolean).join(' ')}>
        <summary className="p-3 fw-medium text-body" style={{ cursor: 'pointer' }}>
          {t('tpp.modal_guide_toggle', { defaultValue: '使い方' })}
        </summary>
        <div className="px-3 pb-3 pt-0 border-top">
          <GuideContent introKey={introKey} stepKeys={stepKeys} noteKey={noteKey} />
        </div>
      </details>
    );
  }

  return (
    <div className={['small mb-3 p-3 rounded border bg-light', className].filter(Boolean).join(' ')}>
      <GuideContent introKey={introKey} stepKeys={stepKeys} noteKey={noteKey} />
    </div>
  );
}
